import { Component, OnInit } from '@angular/core';
import { Make, SelectionLists } from '../../entities';
import { AppService } from '../../app.service';
import { GETSetupEquipmentService } from '../GET_NEW_UI/setup-equipment/setup-equipment.service';
import { MakeSetupVM } from '../GET_NEW_UI/setup-equipment/setup-equipment.model';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-make-setup',
  templateUrl: './make-setup.component.html',
  styleUrls: ['./make-setup.component.scss']
})
export class MakeSetupComponent implements OnInit {

  _dropDownLists: SelectionLists = new SelectionLists();
 makeList: Make[] = [];
 CpoyMakeList: Make[] = [];
 selectedMake:string=""
 selectedMakeAutoComplete:string
 makeSymbol:string
 makeName:string
 makeID:number
 isCheckedUndercarriage:boolean=false
 isHideAdd:boolean=false
 isHideUpdate:boolean=true
 isHideDelete:boolean=true
 isCheckedComponent:boolean=false
 isCheckedOEM:boolean=false

  constructor(
    private _appService: AppService,
    private _equipmentService: GETSetupEquipmentService,
    private _notify: NotificationsService,
  ) { }

  ngOnInit() {
    this._appService.setPageTitle('Make Setup');
    this.loadMakes();
  }

  loadMakes() {
  
    this._equipmentService.getMakeListFoeSetUp().subscribe(
      result => {
        this.makeList = result;
       this.CpoyMakeList=result
      },
      error => {
        console.error(error);
      },
      () => {
      }
    );
    
}

changeMakeAutoComplete(event){
  const filterValue = event.target.value.toLowerCase();

  this.makeList = this.CpoyMakeList.filter(option => option.Title.toLowerCase().includes(filterValue));
}
getTitle(makeID: number) {
  return this.makeList.find(u => u.Id == makeID).Title;
}

ChangeCheckbox1(event){
    console.log(event.checked)
    this.isCheckedUndercarriage=event.checked
}
ChangeCheckbox2(event){
  console.log(event.checked)
  this.isCheckedComponent=event.checked
}
ChangeCheckbox3(event){
  console.log(event.checked)
  this.isCheckedOEM=event.checked
}

onSelectMake(event){
  console.log(event.value)
  var filterval= this.makeList.filter(f=>f.Id==event.value)
  console.log(filterval)
  this.makeSymbol=filterval[0].Symbol
  this.makeName=filterval[0].Title
  this.makeID=filterval[0].Id
  this.isHideAdd=true
  this.isHideUpdate=false
  this.isHideDelete=false
  this.isCheckedUndercarriage=filterval[0].isUndecarriage
  this.isCheckedComponent=filterval[0].isComponent
  this.isCheckedOEM=filterval[0].isOEM
}

AddnewMake(){
  let model = new MakeSetupVM()
  model.makeSymbol=this.makeSymbol;
  model.makeName=this.makeName;
  model.isUndercarriage=this.isCheckedUndercarriage;
  model.isComponent=this.isCheckedComponent;
  model.isOEM=this.isCheckedOEM;
this._equipmentService.AddnewMake(model).subscribe(s=>{
  if(s.m_Item1){
    this._notify.success(s.m_Item2)
    this.loadMakes();
  }
  else{
    this._notify.error("Failed to Add")
  }
 
})
}

UpdateMake_(){
  let model = new MakeSetupVM()
  model.makeId=this.makeID
  model.makeSymbol=this.makeSymbol;
  model.makeName=this.makeName;
  model.isUndercarriage=this.isCheckedUndercarriage;
  model.isComponent=this.isCheckedComponent;
  model.isOEM=this.isCheckedOEM;
  this._equipmentService.UpdateMake(model).subscribe(s=>{
    if(s.m_Item1){
      this._notify.success(s.m_Item2)
      this.loadMakes();
    }
    else{
      this._notify.error("Failed to Update")
    }
   
  })

}

deleteMake(){
  let model = new MakeSetupVM()
  model.makeId=this.makeID;
  this._equipmentService.DeleteMake(model).subscribe(s=>{
    if(s.m_Item1){
      this._notify.success(s.m_Item2)
      this.resetFeilds()
      this.loadMakes();
    }
    else{
      this._notify.error("Failed to Delete")
    }
   
  })
  }
resetFeilds(){
  this.selectedMake='';
  this.makeSymbol="";
  this.makeName="";
  this.isCheckedUndercarriage=false;
  this.isHideAdd=false;
  this.isHideUpdate=true;
  this.isHideDelete=true;
  this.selectedMakeAutoComplete='';
  this.isCheckedComponent=false
  this.isCheckedOEM=false
 // this.CpoyMakeList=[]
 // this.makeList=[]
//  this. loadMakes();

}
}
